import axios from '@lib/axios';
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export interface AssetInputs {
  file: any;
}

interface CreateAssetProps {
	onSuccess?: (data: AxiosResponse) => void;
  onError?: (error: AxiosResponse) => void;
}

export const useCreateAsset = ({
	onSuccess,
  onError
}: CreateAssetProps) => {
	const {
		isPending,
		isError,
		error,
		mutate: onCreateAsset,
	} = useMutation({
		mutationFn: async (data: AssetInputs) => {
      return axios.post('/assets/upload', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
		},
		onSuccess,
    onError
	});

	return { onCreateAsset, isPending, isError, error };
};
